export const SET_VOUCHERS = 'SET_VOUCHERS';
export const SET_VOUCHERS_ERROR = 'SET_VOUCHERS_ERROR';
export const SET_APPLIED_VOUCHER = 'SET_APPLIED_VOUCHER';
export const CLEAR_VOUCHERS_DATA = 'CLEAR_VOUCHERS_DATA';
export const CLEAR_SELECTED_VOUCHER = 'CLEAR_SELECTED_VOUCHER';
export const ENABLE_ADD_USER_TO_SEGMENT = 'ENABLE_ADD_USER_TO_SEGMENT';
export const DISABLE_ADD_USER_TO_SEGMENT = 'DISABLE_ADD_USER_TO_SEGMENT';
export const ADD_USER_TO_SEGMENT_SUCCESS = 'ADD_USER_TO_SEGMENT_SUCCESS';
